import { Component } from "react";
import { api } from "@/lib/api";

export const reportError = (message, stack = "") => {
  api.post("/client-errors", { message: String(message).slice(0, 500), stack: String(stack).slice(0, 2000), url: window.location.href.slice(0, 300) }).catch(() => {});
};

export class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  componentDidCatch(error, info) {
    reportError(error?.message || error, `${error?.stack || ""}\n${info?.componentStack || ""}`);
    const last = +sessionStorage.getItem("faunny_reload_at") || 0;
    if (Date.now() - last > 30000) {
      sessionStorage.setItem("faunny_reload_at", String(Date.now()));
      setTimeout(() => window.location.reload(), 400);
    }
  }

  componentDidUpdate(prev) { if (prev.path !== this.props.path && this.state.failed) this.setState({ failed: false }); }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="error-boundary">
        <h1 className="font-display font-black text-4xl text-[#0B1D3A]">Algo no ha cargado bien</h1>
        <p className="text-slate-600 mt-3">Ya nos ha llegado el aviso. Prueba a recargar la página; si vuelve a pasar, desactiva el traductor del navegador.</p>
        <button onClick={() => window.location.reload()} className="mt-6 bg-[#DC2626] hover:bg-[#B91C1C] text-white font-display font-bold text-lg px-8 py-3 rounded-full transition-colors" data-testid="error-reload-button">Recargar</button>
      </div>
    );
  }
}
